import axios from 'axios'

export default axios.create({
    // baseURL: 'https://demo.udiseplus.gov.in/archive-services/v1.1/kpi/',
    //  baseURL: 'https://demo.udiseplus.gov.in/open-services/v1.1/kpi/',
    baseURL: 'https://api.udiseplus.gov.in/open-services/v1.1/kpi/',
    headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        "Authorization": "Bearer df;lkjz8lke4lk345kljsdfkjdfgkljsf08994a/sdfljsdf879w4ra/sdflksdflksdf",
        "Identity":"test"
    }
})